import { HelpIcon } from './HelpIcon';

export function StatusField({ id, label, value, onChange, error, helpText, required, readOnly, options = [] }) {
  const current = options.find(o => o.value === value) || { label: value, color: '#64748b' };
  return (
    <div className="fw">
      <label className="fl">
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div style={{ display:'flex', alignItems:'center', gap:'1rem', marginTop:'0.5rem' }}>
        <div style={{ padding:'4px 12px', borderRadius:'999px', fontSize:'0.75rem', fontWeight:600, background:current.color || '#e2e8f0', color:'white', textTransform:'uppercase', letterSpacing:'0.025em' }}>
          {current.label}
        </div>
        {!readOnly && (
          <select className="field-select" style={{ width:'auto', height:'32px', fontSize:'0.875rem' }}
            value={value} onChange={e => onChange(e.target.value)}>
            {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        )}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
